import { formatOdd } from "@/utils";
import { empty } from "@/utils/empty";
import { useOddsFormat } from "@/utils/providers/odds-format";
import { LineType, Odd2, formatOddOutcomeShort } from "common";
import React from "react";

export default function GameTableOddOutcome({ odd }: { odd?: Odd2 }) {
  const { oddsFormat } = useOddsFormat();
  if (odd !== undefined) {
    const formattedOdd = formatOdd(oddsFormat, odd, true);
    return (
      <div className="flex flex-row gap-2 items-center text-title-sm-medium">
        {odd.outcome !== undefined &&
          (odd.type === LineType.Spread || odd.type === LineType.Moneyline) && (
            <span className="font-bold uppercase">
              {formatOddOutcomeShort(odd.outcome)}
            </span>
          )}
        <span>
          {(formattedOdd?.type === LineType.Moneyline
            ? formattedOdd?.payout
            : formattedOdd?.value) || empty()}
        </span>
      </div>
    );
  }
  return empty();
}
